var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('div',{staticClass:"label mr-2"},[_vm._v(" "+_vm._s(_vm.item.title)+" ")]),(_vm.isUpgradeRequired)?_c(_vm.indicator,{tag:"component",attrs:{"billingFeatureId":_vm.item.billingFeatureId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }